import * as React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Button, Grid, IconButton, Menu, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import { SocialIcon } from "react-social-icons";
import { Download, Envelope, GeoAlt, Phone, Cake2 } from "react-bootstrap-icons";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";


export default function Sidebar({ currentView, setCurrentView }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (/Mobi|Android/i.test(navigator.userAgent)) {
      // If on mobile, open the dialer
      navigator.clipboard.writeText("8686837638")
      .then(() => {
        setOpen(true); // Show the Snackbar
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
      window.location.href = "tel:+918686837638";
    } else {
      // If on desktop, copy the number to the clipboard
      navigator.clipboard.writeText("8686837638")
        .then(() => {
          setOpen(true); // Show the Snackbar
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (view) => {
    setCurrentView(view);
    handleMenuClose();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        "& > :not(style)": {
          m: 1,
          width: 350,
          height: 515,
          borderRadius: 4,
          position: "relative",
          justifyContent: "center",
        },
      }}
    >
      <Paper elevation={3} sx={{ position: "relative" }}>
        <Box
          sx={{
            width: { xs: 80, sm: 100, md: 130 },
            height: { xs: 80, sm: 100, md: 130 },
            background: "black",
            borderRadius: 5,
            position: "absolute",
            top: { xs: -40, sm: -50, md: -65 },
            left: "50%",
            transform: "translateX(-50%)",
            overflow: "hidden",
            zIndex: 3,
          }}
        >
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-falqneJgKriMmmFy2gG5fxOyPKQAikrGiw&usqp=CAU"
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "inherit",
            }}
          />
        </Box>
        {!isSmallScreen ? (
          <>
            <Box
              sx={{
                width: { xs: 80, sm: 100, md: 130 },
                height: { xs: 30, sm: 50, md: 45 },
                background: currentView === 0 ? "#FF6969" : "#d8d8d8",
                borderRadius: 5,
                position: "absolute",
                top: { xs: 20, sm: 20, md: 70 },
                left: "100%",
                transform: "translateX(-50%)",
                overflow: "hidden",
                clipPath: 'polygon(50% 0%, 100% 0%, 100% 100%, 50% 100%)',
                zIndex: 1,
                color: currentView === 0 ? "#fff" : "#000",
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
              onClick={() => setCurrentView(0)}
            />
            <Typography
              variant="body1"
              sx={{
                zIndex: 2,
                fontSize: '0.8rem',
                textAlign: "center",
                position: "absolute",
                top: { xs: 50, sm: 20, md: 80 },
                left: "calc(100% + 27px)",
                transform: "translateX(-50%)",
                color: currentView === 0 ? "#fff" : "#000",
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
              onClick={() => setCurrentView(0)}
            >
              Profile
            </Typography>
            <Box
              sx={{
                width: { xs: 80, sm: 100, md: 130 },
                height: { xs: 30, sm: 50, md: 45 },
                background: currentView === 1 ? "#FF6969" : "#d8d8d8",
                borderRadius: 5,
                position: "absolute",
                top: { xs: 125, sm: 125, md: 125 },
                left: "100%",
                transform: "translateX(-50%)",
                overflow: "hidden",
                zIndex: 1, 
                clipPath: 'polygon(50% 0%, 100% 0%, 100% 100%, 50% 100%)',
                color: currentView === 1 ? "#fff" : "#000",
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
              onClick={() => setCurrentView(1)}
            />
            <Typography
              variant="body1"
              sx={{
                zIndex: 2,
                fontSize: '0.8rem',
                textAlign: "center",
                position: "absolute",
                top: { xs: 125, sm: 125, md: 135 },
                left: "calc(100% + 29px)",
                transform: "translateX(-50%)",
                color: currentView === 1 ? "#fff" : "#000",
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
              onClick={() => setCurrentView(1)}
            >
              Anne_AI
            </Typography>
          </>
        ) : (
          <>
            <IconButton
              sx={{
                position: "absolute",
                top: 10,
                right: 10,
                zIndex: 2,
              }}
              onClick={handleMenuOpen}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={() => handleMenuItemClick(0)}>Profile</MenuItem>
              <MenuItem onClick={() => handleMenuItemClick(1)}>Anne_AI</MenuItem>
            </Menu>
          </>
        )}
        <Typography variant="h5" sx={{ marginTop: 9, textAlign: "center" }}>
          Ajaykumar Ks
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontSize: ".8rem", marginTop: 1, textAlign: "center" }}
        >
          Web Developer
        </Typography>

        {/* Social icons */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 2,
            paddingX: 9,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={4} sx={{ display: "flex", justifyContent: "center" }}>
              <SocialIcon
                url="https://github.com/ajay-kumar-ks"
                style={{ width: 30, height: 30 }}
                target="_blank"
                rel="noopener noreferrer"
              />
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", justifyContent: "center" }}>
              <SocialIcon
                url="https://www.linkedin.com/in/ajaykumarks"
                style={{ width: 30, height: 30 }}
                target="_blank"
                rel="noopener noreferrer"
              />
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", justifyContent: "center" }}>
              <SocialIcon
                url="https://x.com/"
                style={{ width: 30, height: 30 }}
                target="_blank"
                rel="noopener noreferrer"
              />
            </Grid>
          </Grid>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            marginTop: "20px",
          }}
        >
          <Box
            sx={{
              width: "87%",
              background: "#EEEEEE",
              borderRadius: "5px",
              paddingX: "30px",
              paddingY: "10px",
            }}
          >
            <Box sx={{ display: "flex", marginY: '20px' }}>
              <Box
                sx={{
                  width: "27px",
                  height: "27px",
                  background: "white",
                  boxShadow: "0px 0px 4px #b1b1b1",
                  borderRadius: "3px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Phone size={21} color="#0F67B1" />
              </Box>
              <Box
                sx={{ marginLeft: "9px", cursor: "pointer", '&:hover': { color: 'blue' }  }}
                onClick={handleClick}
              >
                91+ 8686837638
              </Box>
              <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
                <MuiAlert
                  onClose={handleClose}
                  severity="success"
                  sx={{ width: "100%" }}
                >
                  Phone number copied to clipboard!
                </MuiAlert>
              </Snackbar>
            </Box>
            <Box sx={{ display: "flex", marginY: '20px' }}>
              <Box
                sx={{
                  width: "27px",
                  height: "27px",
                  background: "white",
                  boxShadow: "0px 0px 4px #b1b1b1",
                  borderRadius: "3px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Envelope size={21} color="#379777" />
              </Box>
              <Box sx={{ marginLeft: "9px", }}>
              <a 
                href="mailto:Ksajaykumar73@gmail.com" 
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Ksajaykumar73@gmail.com
              </a>
            </Box>

            </Box>
            <Box sx={{ display: "flex", marginY: '20px' }}>
              <Box
                sx={{
                  width: "27px",
                  height: "27px",
                  background: "white",
                  boxShadow: "0px 0px 4px #b1b1b1",
                  borderRadius: "3px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <GeoAlt size={21} color="#FF6969" />
              </Box>
              <Box sx={{ marginLeft: "9px" }}>
                Adimali, Idukki
              </Box>
            </Box>
            <Box sx={{ display: "flex", marginY: '20px' }}>
              <Box
                sx={{
                  width: "27px",
                  height: "27px",
                  background: "white",
                  boxShadow: "0px 0px 4px #b1b1b1",
                  borderRadius: "3px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Cake2 size={21} color="#006989" />
              </Box>
              <Box sx={{ marginLeft: "9px" }}>
                8<sup>th</sup> Jan 2004
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ paddingY: "30px", textAlign: "center" }}>
          <Button variant="contained" sx={{ color: "#fff", backgroundColor: '#FF6969' }} startIcon={<Download />}>
            Download Resume
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
